import React, { useState, useEffect } from 'react'
import ProgressBar from './ProgressBar'
import task_md from '../assets/task_md.svg'
import category_task from '../assets/category_task.svg'
import arrow_task_show_category from '../assets/arrow_task_show_category.svg'
import task_md_hover from '../assets/task_md_hover.svg'
import task_category_hover from '../assets/task_category_hover.svg'
import warning_task from '../assets/warning_task.svg'
import { styled } from '@mui/material/styles';
import project_warning from '../assets/project_warning.svg';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip placement="right" {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#265E85',
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#265E85',
    },
}));

function TaskCard({ task, handleClick , index, values}) {
    const [isHovering, setIsHovering] = useState(false);
    const [contracted , setContracted] = useState(0)
    const [forecasted , setForecasted] = useState(0)
    const [spent , setSpent] = useState(0)

    useEffect(() => {
        if(values ){
            setSpent(values.Spent)
            setContracted(values.Contracted)
            setForecasted(values.Forecasted)
        }
    }, [])

    const percent=(a, b)=>{
        if (b===0) return 0
        return Math.round((a/b)*100)
    }
    const percentUpgraded=(a, b)=>{
        if (b===0) return 0
        return Math.round((b-a/b)*100)
    }
    const error = Math.round(spent) > Math.round(forecasted)|| Math.round(spent) > Math.round(contracted)
    let readings = [
        {
            name: 'Spent',
            value: (forecasted > contracted)? spent/forecasted *100 : spent/(contracted )*100,
            color: '#00A486'
        },
        {
            name: 'Forecasted',
            value: (forecasted > contracted)? (forecasted - spent)/ forecasted *100 : (forecasted - spent)/(contracted )*100,
            color: '#BCD4E4'
        },{
            name: 'Contracted',
            value: (forecasted > contracted) ? 0 : (contracted - forecasted)/ contracted *100,
            color: '#FFFFFF'
        }
    ];
    let readings_error = [
        {
            name: 'error',
            value: 100,
            color: '#D6405B'
        }
    ];
    let readings_upgraded = [
        {
            name: 'Spent',
            value: 99,
            color: '#FFFFFF'
        },
    ]
    return (
        <div
            className='card-task'
            onMouseOver={() => setIsHovering(true)}
            onMouseOut={() => setIsHovering(false)}
            onClick={() =>handleClick(task.TaskID)}
        >
            <img src={isHovering ? task_md_hover : task_md} alt='#' />
            <div className={isHovering ? 'task-name-task-hover' : 'task-name-task'}>
                {task.TaskName}
                &nbsp;
                {
            task.nb_expenses > 0 ?
            <BootstrapTooltip title="New imported expenses to link">
          <img src={project_warning} alt='#'/>
          </BootstrapTooltip>
          : <></>
          }
            </div>
            <div className={isHovering ? 'category-task-hover' : 'category-task'}>
             
            </div>
            <div>
                <ProgressBar readings={Math.round(forecasted) < Math.round(spent) ? readings_error : forecasted===0 ? readings_upgraded : readings} width={'290px'} />
            </div>
            <div className={isHovering ? 'details-task-hover' : 'details-task'}>
                <p>
                    Total Contracted:
                    &nbsp;
                    <span className={isHovering ? 'amount-task-hover' : 'amount-task'}> {Math.round(contracted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} </span>
                </p>
                <p>
                    Total Forecasted:
                    &nbsp;
                    <span className={isHovering ? 'amount-task-hover' : 'amount-task'}>{Math.round(forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                    &nbsp;&nbsp;
                    <span>
                        <BootstrapTooltip title="Forecast exceeds contract">
                    { forecasted > contracted ?  <img  src={warning_task} alt='#' /> : <span></span>}
                    </BootstrapTooltip>
                    </span>
                </p>
                <p>
                    Total Actuals:
                    &nbsp;
                    <span style={{color: Math.round(forecasted) >= Math.round(spent) ? '#00A486': '#D6405B' }} className={isHovering ? 'amount-task-hover' : 'amount-task'}>
                         {Math.round(spent).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                         &nbsp;
                         { forecasted ? '('+ Math.round(spent / forecasted * 100) +')%' : ''}
                         </span>
                </p>
            </div>
            <div className={isHovering ? 'select-task-hover' : 'select-task'}>
                Cost Categories
                <img src={arrow_task_show_category} alt='#' />
            </div>
        </div>
    )
}

export default TaskCard